import LOADER from '@ott/utility-loader';
import T from './types';

const initialState = {
  from: {},
  to: {},
  ...LOADER.initial(),
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case T.GET_SEARCH_DATA: {
      return {
        ...initialState,
        ...LOADER.begin(),
      };
    }

    case T.GET_SEARCH_DATA_SUCCESS: {
      return {
        ...LOADER.success(),
        ...action.result,
      };
    }

    case T.GET_SEARCH_DATA_FAIL: {
      const { error } = action;

      return {
        ...initialState,
        ...LOADER.error(error),
      };
    }

    case T.GET_SEARCH_DATA_RESET: {
      return {
        ...initialState,
        ...(action.cancelled ? LOADER.cancelled() : {}),
      };
    }

    default: {
      return state;
    }
  }
}

export default reducer;
